import { tfpapi } from './trainfitpro-apiservice';

// Allow dependency injection for testing
import { createApiInjector } from './api-injector';
export const mediaMgmtApiInjector = createApiInjector(tfpapi);

export class MediaMgmtService {

  // static async getImageUploadUrl(userUUID: string, description: string, type: string) {
  //   const result = await tfpapi.media.getImageUploadUrl({ userUUID }, { description, type });

  //   if (result.data?.status) {
  //     return result.data.result;
  //   }

  //   return undefined;
  // }

  static async getImageDownloadUrl(userUUID: string, mediaUUID: string, variant: string) {
    const result = await mediaMgmtApiInjector.api.media.getImageDownloadUrl({ userUUID, imageId: mediaUUID, variant })

    if (result.data?.status) {
      return result.data.data?.url;
    }
    return undefined;
  }

  // this is done via the uppy client so maybe the implementation should go in this file???

  // static async getVideoUploadUrl(userUUID: string, description: string, length: number, type: 'chat'|'instruction') {
  //   const result = await tfpapi.media.getVideoUploadUrl({ userUUID }, { description, length, type });

  //   if (result.data?.status) {
  //     return result.data.data.destinationurl;
  //   }

  //   return undefined;
  // }

  static async getVideoDownloadToken(userUUID: string, mediaUUID: string) {
    const result = await mediaMgmtApiInjector.api.media.getVideoDownloadToken({ userUUID, videoId: mediaUUID })

    if (result.data?.status) {
      return result.data.data.videoToken;
    }
    return undefined;
  }

}
